module.exports = __webpack_public_path__ + "static/media/space-invasion.gb.4b4c6520.zip";